import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    TimelineBodyDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";

const stylesheet = StyleSheet.create({
    container: {
        alignSelf: "stretch"
    }
});

export const useStyles = ({
    controlPaddings,
    shapeConfigs,
    radiuses,
    colors,
    spaces
}: TimelineBodyDynamicStyleType) => {
    const styles = {
        container: {
            backgroundColor: colors.content.container.subtle,
            paddingHorizontal: controlPaddings.small,
            paddingVertical: spaces.spacingSm,
            maxWidth: shapeConfigs.chatWidth,
            marginTop: spaces.spacingXxs,
            ...getCornerStyle({
                radius: radiuses.form,
                shapeConfigs
            })
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
